module.exports = __webpack_public_path__ + "img/problem4.1457d795.png";